import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { getFieldErrors } from "../helpers";
import { IUser, tryConfirmLogin } from "./authReducer";

export interface IVehicle {
    _id: string;
    type?: string;
    number?: string;
}

export interface IDriver extends IUser {
    vehicle?: IVehicle;
    ordersCount?: number;
    pickUpsCount?: number;       //Pick-ups assigned to this Driver
    pendingServicesPlansCount?: number;
}

export interface IDriversState {
    fetchingDrivers: boolean;
    fetchDriversErr: string | null;
    drivers: IDriver[];
    fetchingMainDriver: boolean;
    fetchMainDriverErr: string | null;
    mainDriverId: string | null;
    mainDriver: IDriver | null;
}

const initialState = {
    // mainDriver: {
    //     _id: 'oiwewioidecd',
    //     imgSrc: '',
    //     firstName: 'Olamide',
    //     lastName: 'Falade',
    //     email: 'ofalade326@stu.ui.edu.ng',
    //     emailVerified: true,
    //     status: 'active',
    //     ordersCount: 3,
    //     pickUpsCount: 2,
    // },
    fetchingDrivers: false,
    fetchDriversErr: null,
    drivers: [],
    fetchingMainDriver: false,
    fetchMainDriverErr: null,
    mainDriverId: null,
    mainDriver: null,
} as IDriversState;


const driversSlice = createSlice({
    name: 'drivers',
    initialState,
    reducers: {
        fetchDriversStart: (state: IDriversState) => {
            state.fetchingDrivers = true;
        },
        fetchDriversPass: (state: IDriversState, action: PayloadAction<IDriver[]>) => {
            state.fetchingDrivers = false;

            state.drivers = action.payload;
        },
        fetchDriversFail: (state: IDriversState, action: PayloadAction<string>) => {
            state.fetchingDrivers = false;
            state.fetchDriversErr = action.payload;
        },
        clearFetchMainDriverErr: (state: IDriversState) => {
            state.fetchMainDriverErr = null;
        },
        fetchMainDriverStart: (state: IDriversState) => {
            state.fetchingMainDriver = true;
            state.fetchMainDriverErr = null;
        },
        fetchMainDriverPass: (state: IDriversState, action: PayloadAction<IDriver>) => {
            state.fetchingMainDriver = false;
            state.mainDriver = action.payload;

        },
        fetchMainDriverFail: (state: IDriversState, action: PayloadAction<string>) => {
            state.fetchingMainDriver = false;
            state.fetchMainDriverErr = action.payload;
        },
        setMainDriverId: (state: IDriversState, action: PayloadAction<string | null>) => {
            state.mainDriverId = action.payload;
        },
        setMainDriver: (state: IDriversState, action: PayloadAction<IDriver | null>) => {
            state.mainDriver = action.payload;
        }
    }

})

export const {
    fetchDriversStart,
    fetchDriversPass,
    fetchDriversFail,
    clearFetchMainDriverErr,
    fetchMainDriverStart,
    fetchMainDriverPass,
    fetchMainDriverFail,
    setMainDriver,
    setMainDriverId,
} = driversSlice.actions;


interface ITryFetchDriversArg {
    authToken: string;
}


export const tryFetchDrivers = createAsyncThunk('customers/tryFetchDrivers', (arg: ITryFetchDriversArg, { dispatch }) => {
    const endpoint = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/drivers`;

    const { authToken } = arg;

    dispatch(fetchDriversStart());
    axios.get(endpoint, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        }
    }).then(res => {
        dispatch(fetchDriversPass(res.data.drivers));
    }).catch(err => {
        const data = err?.response?.data;

        if (data?.err && (data.err === "Session expired")) {
            dispatch(tryConfirmLogin({authToken}));
            return;
        }

        if (data?.err) {
            dispatch(fetchDriversFail(data.err));
        } else {
            dispatch(fetchDriversFail('Check your network connection.'))
        }

    });
});


interface ITryFetchMainDriverArg {
    authToken: string;
    driverId: string;
}

export const tryFetchMainDriver = createAsyncThunk('drivers/tryFetchMainDriver', (arg: ITryFetchMainDriverArg, { dispatch }) => {
    const { authToken, driverId } = arg;

    const endpoint = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/drivers/${driverId}`;

    dispatch(fetchMainDriverStart());
    axios.get(endpoint, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        }
    }).then(res => {
        const data = res.data;

        dispatch(fetchMainDriverPass(res.data));
    }).catch(err => {
        const data = err?.response?.data;

        if (data?.err && (data.err === "Session expired")) {
            dispatch(tryConfirmLogin({authToken}));
            return;
        }

        if (data?.errors) {
            dispatch(fetchMainDriverFail(getFieldErrors(data.errors)[0].msg));
        } else if (data?.err) {
            dispatch(fetchMainDriverFail(data.err));
        } else {
            dispatch(fetchMainDriverFail('Check your network connection.'));
        }
    });
});

export default driversSlice.reducer;

